/* eslint-disable */
/**
 * This file was generated by TypeScriptGen v0.0.3
 * Any changes to this file will be lost if regenerated 
 */
import Axios, {AxiosResponse} from 'axios';
import {queryUrl, toFormData, defaultConfig, defaultFormConfig, contentOnly} from "./helper";
import InterpolationAlgorithmType from "./InterpolationAlgorithmType";
import FileContentResult from "./FileContentResult";

const urls = {
    getInterpolation(programId: number, amendment: string, year: string, algorithm: InterpolationAlgorithmType): string {
        return queryUrl("/interpolation/getinterpolation", {programId, amendment, year, algorithm});
    },
    getMockInterpolation(condenseRatio: number, algorithm: InterpolationAlgorithmType, seed: number): string {
        return queryUrl("/interpolation/getmockinterpolation", {condenseRatio, algorithm, seed});
    }
}

export default {
    urls,
    getInterpolation(programId: number, amendment: string, year: string, algorithm: InterpolationAlgorithmType): Promise<void> {
        return contentOnly(Axios.get(queryUrl("/interpolation/getinterpolation", {programId, amendment, year, algorithm}), defaultConfig));
    },
    getMockInterpolation(condenseRatio: number, algorithm: InterpolationAlgorithmType, seed: number): Promise<FileContentResult> {
        return contentOnly(Axios.get(queryUrl("/interpolation/getmockinterpolation", {condenseRatio, algorithm, seed}), defaultConfig));
    }
}
